export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于爱漫画</h2>
          <p className="text-sm text-foreground-500">为漫画爱好者打造的免费在线阅读平台</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              非常爱漫画成立于2020年，致力于为广大漫画爱好者提供最优质的免费在线阅读体验。平台汇聚海量国漫、日漫、韩漫资源，涵盖热血、恋爱、悬疑、搞笑、奇幻等全品类题材，满足不同读者的多样化需求。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们采用独创的下拉式阅读模式，告别传统翻页的割裂感，让读者沉浸在流畅连贯的漫画世界中。无论使用电脑、平板还是手机，都能获得一致的畅快阅读体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              爱漫画坚持每日同步更新，热门连载作品第一时间上线，让追更党不再等待。所有漫画内容均可免费阅读，无需注册登录，点击即看，真正做到"随时随地，想看就看"。未来我们将持续扩充漫画资源库，优化阅读体验，让每一位来到爱漫画的读者都能找到自己喜欢的作品。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/70">
            {[
              { num: '10万+', label: '漫画资源' },
              { num: '50万+', label: '日活跃用户' },
              { num: '每日更新', label: '同步追更' },
              { num: '98%', label: '用户好评' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-500">{stat.num}</div>
                <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}